module.exports = __webpack_public_path__ + "assets/ziyuan_14.7628c90d.svg";